import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconChartBars24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconChartBars24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.5 4.25a.75.75 0 0 0-1.5 0v12a.75.75 0 0 0 1.5 0zM11.75 17a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 1.5 0v9a.75.75 0 0 1-.75.75m-7.25-.75a.75.75 0 0 0 1.5 0v-4a.75.75 0 0 0-1.5 0zM4 18.5A.75.75 0 0 0 4 20h16a.75.75 0 0 0 0-1.5zM15.25 17a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-.75.75m-7.75-.75a.75.75 0 0 0 1.5 0v-2a.75.75 0 0 0-1.5 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconChartBars24);
